import { render, staticRenderFns } from "./VApp.vue?vue&type=template&id=a31f3d84&"
import script from "./VApp.vue?vue&type=script&lang=js&"
export * from "./VApp.vue?vue&type=script&lang=js&"
import style0 from "./VApp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./_toaster.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports